import React, { useEffect, useState } from 'react';
import AddToCalendar from 'zuddl-react-add-to-calendar';
import api from '@/api';
import { IEventRoleOptions } from '@/types/eventRole';
import Loader from '@/components/ui/Loader';
import styles from './styles.module.scss';

const AddToCalendarComponent = ({ event, currentUserEventPermissions }) => {
  const icon = { calendar: 'left' };

  const { startDateTime, endDateTime, eventId } = event;

  const [showLoader, setShowLoader] = useState(true);

  const eventRoleId =
    currentUserEventPermissions && currentUserEventPermissions.eventRoleId;

  const role = currentUserEventPermissions && currentUserEventPermissions.role;

  let eventUrl = window.location.href;

  const { origin } = window.location;
  if (origin === 'https://www.nasscom-engineering-summit.com') {
    if (eventRoleId) {
      eventUrl = `https://app.zuddl.com${window.location.pathname}?r=${eventRoleId}`;
    }
  }

  const [calenderDetails, setCalenderDetails] = useState({
    title: event.title,
    description: `${event.description} \n\n\n <b>Event URL:</b> \n <a>${eventUrl}</a>`,
    location: eventUrl,
    startTime: startDateTime,
    endTime: endDateTime,
    url: eventUrl,
  });

  useEffect(() => {
    let url = '';
    if (!eventId) {
      return;
    }

    api.pageBuilder.getLandingPageLink(eventId).then(({ data }) => {
      if (data) {
        if (role === IEventRoleOptions.ATTENDEE && data.attendeeUrl) {
          url = data.attendeeUrl;
        } else if (data.speakerUrl) {
          url = data.speakerUrl;
        }
      }

      setCalenderDetails({
        ...calenderDetails,
        location: url,
        description: `${event.description} \n\n\n <b>Event URL:</b> \n <a>${url}</a>`,
        url: url,
      });

      setShowLoader(false);
    });

  }, []);

  return showLoader ? (
    <div className={styles.calenderLoader}>
      <Loader />
    </div>
  ) : (
    <AddToCalendar
      event={calenderDetails}
      buttonTemplate={icon}
      buttonLabel="&nbsp;&nbsp;Add To Calendar"
    />
  );
};

export default AddToCalendarComponent;